<template>
    <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer flex-col">
        <div v-show="showModal" id="myModal" class="modal">
            <div class="modal-content flex-col">
                <img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/askQuestion/sent_messages.png" alt="" class="lazyload">
                <img v-else data-src="/media/askQuestion/sent_messages.png" alt="" class="lazyload">
                <h3 v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Ваш вопрос отправлен</h3>
                <h3 v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#568357' }">Сіздің сұрағыңыз жіберілді</h3>
                <p v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Наши специалисты приступили к обработке вашего вопроса</p>
                <p v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#000000' : '#4F4F4F' }">Біздің мамандар сіздің сұрағыңызды өңдеуге кірісті</p>
                <span v-if="lang === 'ru'" @click="$router.go()" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }">Готово</span>
                <span v-if="lang === 'kk'" @click="$router.go()" :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }">Дайын</span>
            </div>
        </div>
        <directory :route="$route"></directory>
        <h1 v-if="lang === 'ru'">Контакты</h1>
        <h1 v-if="lang === 'kk'">Байланыс ақпараты</h1>
        <div class="content flex-row">
            <div class="left flex-col">
                <img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/contact/Group.png" alt="" class="lazyload">
                <img v-else data-src="/media/contact/Group.png" alt="" class="lazyload">
                <h5 v-if="lang === 'ru'" style="margin-top: 350px;">Адрес</h5>
                <h5 v-if="lang === 'kk'" style="margin-top: 350px;">Мекенжай</h5>
                <p v-if="lang === 'ru'">г. Алматы, Орбита-1, дом 1</p>
                <p v-if="lang === 'kk'">г. Алматы, Орбита-1, дом 1</p>
                <h5 v-if="lang === 'ru'">Контакты</h5>
                <h5 v-if="lang === 'kk'">Байланыс ақпараттары</h5>
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="#4F4F4F"/>
                    </svg>
                    <a v-if="lang === 'ru'" href="tel:87029466996">8 702 946 69 96</a>
                    <a v-if="lang === 'kk'" href="tel:87029466996">8 702 946 69 96</a>
                </div>
                <!-- <div class="label flex-row">
                    <svg style="margin-top: 4px" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="#4F4F4F"/>
                    </svg>
                    <a v-if="lang === 'ru'" href="tel:87029466996">8 702 946 69 96</a>
                    <a v-if="lang === 'kk'" href="tel:87029466996">8 702 946 69 96</a>
                </div> -->
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z" fill="#4F4F4F"/>
                    </svg>
                    <a v-if="lang === 'ru'" style="font-weight: 500;">fpf.kaz@gmail.com</a>
                    <a v-if="lang === 'kk'" style="font-weight: 500;">fpf.kaz@gmail.com</a>
                </div>
                <div class="label flex-row">
                    <svg style="margin-top: 4px" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z" fill="#4F4F4F"/>
                    </svg>
                    <a v-if="lang === 'ru'" style="font-weight: 500;">www.shyn.kz</a>
                    <a v-if="lang === 'kk'" style="font-weight: 500;">www.shyn.kz</a>
                </div>
            </div>
            <div :style="{ 'color': data.impairedRegime ? '#ffffff' : '#568357', 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4' }" class="right flex-col">
                <h3 v-if="lang === 'ru'">Вопросы и предложения</h3>
                <h3 v-if="lang === 'kk'">Сұрақтар мен ұсыныстар</h3>
                <label v-if="lang === 'ru'">Имя</label>
                <label v-if="lang === 'kk'">Аты-жөні</label>
                <input v-if="lang === 'ru'" v-model="name" v-on:keyup="validateForm($event)" name="name" type="text" maxlength="30" placeholder="Введите ваше имя">
                <input v-if="lang === 'kk'" v-model="name" v-on:keyup="validateForm($event)" name="name" type="text" maxlength="30" placeholder="Аты-жөніңізді жазыңыз">
                <div id="err-name" class="err flex-row">
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1" fill="white">
                        <path d="M5.30523 0.584523L0.162726 9.16952C0.0566992 9.35314 0.000598436 9.56131 4.76129e-06 9.77334C-0.000588914 9.98536 0.0543452 10.1939 0.159342 10.3781C0.264339 10.5623 0.415738 10.7158 0.598477 10.8233C0.781216 10.9308 0.988925 10.9886 1.20094 10.991H11.4859C11.698 10.9886 11.9057 10.9308 12.0884 10.8233C12.2711 10.7158 12.4225 10.5623 12.5275 10.3781C12.6325 10.1939 12.6875 9.98536 12.6869 9.77334C12.6863 9.56131 12.6302 9.35314 12.5242 9.16952L7.38165 0.584523C7.27342 0.406088 7.12102 0.25856 6.93917 0.156174C6.75731 0.053788 6.55214 0 6.34344 0C6.13474 0 5.92957 0.053788 5.74771 0.156174C5.56586 0.25856 5.41346 0.406088 5.30523 0.584523Z"/>
                        <path d="M6.95057 8.5624C6.95057 8.89772 6.67874 9.16955 6.34343 9.16955C6.00811 9.16955 5.73628 8.89772 5.73628 8.5624C5.73628 8.22709 6.00811 7.95526 6.34343 7.95526C6.67874 7.95526 6.95057 8.22709 6.95057 8.5624Z"/>
                        </mask>
                        <path d="M6.69344 3.70524C6.69344 3.51194 6.53674 3.35524 6.34344 3.35524C6.15014 3.35524 5.99344 3.51194 5.99344 3.70524H6.69344ZM5.99344 6.13381C5.99344 6.32711 6.15014 6.48381 6.34344 6.48381C6.53674 6.48381 6.69344 6.32711 6.69344 6.13381H5.99344ZM5.99344 3.70524V6.13381H6.69344V3.70524H5.99344ZM5.30523 0.584523L4.70672 0.221478L4.70472 0.224813L5.30523 0.584523ZM0.162726 9.16952L-0.437858 8.80977L-0.443468 8.81948L0.162726 9.16952ZM1.20094 10.991L1.19325 11.691H1.20094V10.991ZM11.4859 10.991V11.691L11.4936 11.6909L11.4859 10.991ZM12.5242 9.16952L13.1304 8.81944L13.1247 8.80981L12.5242 9.16952ZM7.38165 0.584523L7.98217 0.224808L7.98015 0.221484L7.38165 0.584523ZM6.34344 0V-0.7V0ZM4.70472 0.224813L-0.437781 8.80981L0.763233 9.52923L5.90573 0.944233L4.70472 0.224813ZM-0.443468 8.81948C-0.610615 9.10894 -0.699057 9.43712 -0.699992 9.77138L0.700002 9.7753C0.700253 9.6855 0.724014 9.59733 0.768919 9.51957L-0.443468 8.81948ZM-0.699992 9.77138C-0.700928 10.1056 -0.614326 10.4343 -0.448802 10.7247L0.767486 10.0314C0.723017 9.9534 0.699751 9.8651 0.700002 9.7753L-0.699992 9.77138ZM-0.448802 10.7247C-0.283278 11.0151 -0.0446023 11.2571 0.243481 11.4266L0.953473 10.22C0.876078 10.1744 0.811955 10.1094 0.767486 10.0314L-0.448802 10.7247ZM0.243481 11.4266C0.531562 11.5961 0.859009 11.6872 1.19325 11.6909L1.20863 10.291C1.11884 10.29 1.03087 10.2655 0.953473 10.22L0.243481 11.4266ZM1.20094 11.691H11.4859V10.291H1.20094V11.691ZM11.4936 11.6909C11.8279 11.6872 12.1553 11.5961 12.4434 11.4266L11.7334 10.22C11.656 10.2655 11.568 10.29 11.4782 10.291L11.4936 11.6909ZM12.4434 11.4266C12.7315 11.2571 12.9702 11.0151 13.1357 10.7247L11.9194 10.0314C11.8749 10.1094 11.8108 10.1744 11.7334 10.22L12.4434 11.4266ZM13.1357 10.7247C13.3012 10.4343 13.3878 10.1056 13.3869 9.77138L11.9869 9.7753C11.9871 9.8651 11.9639 9.9534 11.9194 10.0314L13.1357 10.7247ZM13.3869 9.77138C13.3859 9.43712 13.2975 9.10894 13.1303 8.81948L11.918 9.51957C11.9629 9.59733 11.9866 9.6855 11.9869 9.7753L13.3869 9.77138ZM13.1247 8.80981L7.98216 0.224813L6.78115 0.944233L11.9236 9.52923L13.1247 8.80981ZM7.98015 0.221484C7.80952 -0.0598146 7.56927 -0.292388 7.28258 -0.453796L6.59575 0.766144C6.67277 0.809508 6.73731 0.87199 6.78315 0.947563L7.98015 0.221484ZM7.28258 -0.453796C6.99589 -0.615205 6.67244 -0.7 6.34344 -0.7V0.7C6.43183 0.7 6.51873 0.722781 6.59575 0.766144L7.28258 -0.453796ZM6.34344 -0.7C6.01444 -0.7 5.69099 -0.615205 5.4043 -0.453796L6.09113 0.766144C6.16815 0.722781 6.25505 0.7 6.34344 0.7V-0.7ZM5.4043 -0.453796C5.11761 -0.292388 4.87736 -0.0598146 4.70673 0.221484L5.90373 0.947563C5.94957 0.87199 6.01411 0.809508 6.09113 0.766144L5.4043 -0.453796ZM6.25057 8.5624C6.25057 8.51112 6.29214 8.46955 6.34343 8.46955V9.86955C7.06534 9.86955 7.65057 9.28432 7.65057 8.5624H6.25057ZM6.34343 8.46955C6.39471 8.46955 6.43628 8.51112 6.43628 8.5624H5.03628C5.03628 9.28432 5.62151 9.86955 6.34343 9.86955V8.46955ZM6.43628 8.5624C6.43628 8.61369 6.39471 8.65526 6.34343 8.65526V7.25526C5.62151 7.25526 5.03628 7.84049 5.03628 8.5624H6.43628ZM6.34343 8.65526C6.29214 8.65526 6.25057 8.61369 6.25057 8.5624H7.65057C7.65057 7.84049 7.06534 7.25526 6.34343 7.25526V8.65526Z" fill="#D06262" mask="url(#path-1-inside-1)"/>
                    </svg>
                    <span v-if="lang === 'ru'">Это обязательное поле</span>
                    <span v-if="lang === 'kk'">Бұл жолды міндетті түрде жазу қажет</span>
                </div>
                <label v-if="lang === 'ru'">Email адрес</label>
                <label v-if="lang === 'kk'">Электронды пошта</label>
                <input v-if="lang === 'ru'" v-model="email" v-on:keyup="validateForm($event)" name="email" type="text" maxlength="30" placeholder="Введите ваш Email">
                <input v-if="lang === 'kk'" v-model="email" v-on:keyup="validateForm($event)" name="email" type="text" maxlength="30" placeholder="Электронды поштаңызды жазыңыз">
                <div id="err-mail" class="err flex-row">
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1" fill="white">
                        <path d="M5.30523 0.584523L0.162726 9.16952C0.0566992 9.35314 0.000598436 9.56131 4.76129e-06 9.77334C-0.000588914 9.98536 0.0543452 10.1939 0.159342 10.3781C0.264339 10.5623 0.415738 10.7158 0.598477 10.8233C0.781216 10.9308 0.988925 10.9886 1.20094 10.991H11.4859C11.698 10.9886 11.9057 10.9308 12.0884 10.8233C12.2711 10.7158 12.4225 10.5623 12.5275 10.3781C12.6325 10.1939 12.6875 9.98536 12.6869 9.77334C12.6863 9.56131 12.6302 9.35314 12.5242 9.16952L7.38165 0.584523C7.27342 0.406088 7.12102 0.25856 6.93917 0.156174C6.75731 0.053788 6.55214 0 6.34344 0C6.13474 0 5.92957 0.053788 5.74771 0.156174C5.56586 0.25856 5.41346 0.406088 5.30523 0.584523Z"/>
                        <path d="M6.95057 8.5624C6.95057 8.89772 6.67874 9.16955 6.34343 9.16955C6.00811 9.16955 5.73628 8.89772 5.73628 8.5624C5.73628 8.22709 6.00811 7.95526 6.34343 7.95526C6.67874 7.95526 6.95057 8.22709 6.95057 8.5624Z"/>
                        </mask>
                        <path d="M6.69344 3.70524C6.69344 3.51194 6.53674 3.35524 6.34344 3.35524C6.15014 3.35524 5.99344 3.51194 5.99344 3.70524H6.69344ZM5.99344 6.13381C5.99344 6.32711 6.15014 6.48381 6.34344 6.48381C6.53674 6.48381 6.69344 6.32711 6.69344 6.13381H5.99344ZM5.99344 3.70524V6.13381H6.69344V3.70524H5.99344ZM5.30523 0.584523L4.70672 0.221478L4.70472 0.224813L5.30523 0.584523ZM0.162726 9.16952L-0.437858 8.80977L-0.443468 8.81948L0.162726 9.16952ZM1.20094 10.991L1.19325 11.691H1.20094V10.991ZM11.4859 10.991V11.691L11.4936 11.6909L11.4859 10.991ZM12.5242 9.16952L13.1304 8.81944L13.1247 8.80981L12.5242 9.16952ZM7.38165 0.584523L7.98217 0.224808L7.98015 0.221484L7.38165 0.584523ZM6.34344 0V-0.7V0ZM4.70472 0.224813L-0.437781 8.80981L0.763233 9.52923L5.90573 0.944233L4.70472 0.224813ZM-0.443468 8.81948C-0.610615 9.10894 -0.699057 9.43712 -0.699992 9.77138L0.700002 9.7753C0.700253 9.6855 0.724014 9.59733 0.768919 9.51957L-0.443468 8.81948ZM-0.699992 9.77138C-0.700928 10.1056 -0.614326 10.4343 -0.448802 10.7247L0.767486 10.0314C0.723017 9.9534 0.699751 9.8651 0.700002 9.7753L-0.699992 9.77138ZM-0.448802 10.7247C-0.283278 11.0151 -0.0446023 11.2571 0.243481 11.4266L0.953473 10.22C0.876078 10.1744 0.811955 10.1094 0.767486 10.0314L-0.448802 10.7247ZM0.243481 11.4266C0.531562 11.5961 0.859009 11.6872 1.19325 11.6909L1.20863 10.291C1.11884 10.29 1.03087 10.2655 0.953473 10.22L0.243481 11.4266ZM1.20094 11.691H11.4859V10.291H1.20094V11.691ZM11.4936 11.6909C11.8279 11.6872 12.1553 11.5961 12.4434 11.4266L11.7334 10.22C11.656 10.2655 11.568 10.29 11.4782 10.291L11.4936 11.6909ZM12.4434 11.4266C12.7315 11.2571 12.9702 11.0151 13.1357 10.7247L11.9194 10.0314C11.8749 10.1094 11.8108 10.1744 11.7334 10.22L12.4434 11.4266ZM13.1357 10.7247C13.3012 10.4343 13.3878 10.1056 13.3869 9.77138L11.9869 9.7753C11.9871 9.8651 11.9639 9.9534 11.9194 10.0314L13.1357 10.7247ZM13.3869 9.77138C13.3859 9.43712 13.2975 9.10894 13.1303 8.81948L11.918 9.51957C11.9629 9.59733 11.9866 9.6855 11.9869 9.7753L13.3869 9.77138ZM13.1247 8.80981L7.98216 0.224813L6.78115 0.944233L11.9236 9.52923L13.1247 8.80981ZM7.98015 0.221484C7.80952 -0.0598146 7.56927 -0.292388 7.28258 -0.453796L6.59575 0.766144C6.67277 0.809508 6.73731 0.87199 6.78315 0.947563L7.98015 0.221484ZM7.28258 -0.453796C6.99589 -0.615205 6.67244 -0.7 6.34344 -0.7V0.7C6.43183 0.7 6.51873 0.722781 6.59575 0.766144L7.28258 -0.453796ZM6.34344 -0.7C6.01444 -0.7 5.69099 -0.615205 5.4043 -0.453796L6.09113 0.766144C6.16815 0.722781 6.25505 0.7 6.34344 0.7V-0.7ZM5.4043 -0.453796C5.11761 -0.292388 4.87736 -0.0598146 4.70673 0.221484L5.90373 0.947563C5.94957 0.87199 6.01411 0.809508 6.09113 0.766144L5.4043 -0.453796ZM6.25057 8.5624C6.25057 8.51112 6.29214 8.46955 6.34343 8.46955V9.86955C7.06534 9.86955 7.65057 9.28432 7.65057 8.5624H6.25057ZM6.34343 8.46955C6.39471 8.46955 6.43628 8.51112 6.43628 8.5624H5.03628C5.03628 9.28432 5.62151 9.86955 6.34343 9.86955V8.46955ZM6.43628 8.5624C6.43628 8.61369 6.39471 8.65526 6.34343 8.65526V7.25526C5.62151 7.25526 5.03628 7.84049 5.03628 8.5624H6.43628ZM6.34343 8.65526C6.29214 8.65526 6.25057 8.61369 6.25057 8.5624H7.65057C7.65057 7.84049 7.06534 7.25526 6.34343 7.25526V8.65526Z" fill="#D06262" mask="url(#path-1-inside-1)"/>
                    </svg>
                    <span v-if="lang === 'ru'">Это обязательное поле</span>
                    <span v-if="lang === 'kk'">Бұл жолды міндетті түрде жазу қажет</span>
                </div>
                <label v-if="lang === 'ru'">Текст</label>
                <label v-if="lang === 'kk'">Мәтін</label>
                <textarea v-if="lang === 'ru'" v-model="text" v-on:keyup="validateForm($event)" name="text" placeholder="Введите текст"></textarea>
                <textarea v-if="lang === 'kk'" v-model="text" v-on:keyup="validateForm($event)" name="text" placeholder="Мәтінді жазыңыз"></textarea>
                <div id="err-text" class="err flex-row">
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1" fill="white">
                        <path d="M5.30523 0.584523L0.162726 9.16952C0.0566992 9.35314 0.000598436 9.56131 4.76129e-06 9.77334C-0.000588914 9.98536 0.0543452 10.1939 0.159342 10.3781C0.264339 10.5623 0.415738 10.7158 0.598477 10.8233C0.781216 10.9308 0.988925 10.9886 1.20094 10.991H11.4859C11.698 10.9886 11.9057 10.9308 12.0884 10.8233C12.2711 10.7158 12.4225 10.5623 12.5275 10.3781C12.6325 10.1939 12.6875 9.98536 12.6869 9.77334C12.6863 9.56131 12.6302 9.35314 12.5242 9.16952L7.38165 0.584523C7.27342 0.406088 7.12102 0.25856 6.93917 0.156174C6.75731 0.053788 6.55214 0 6.34344 0C6.13474 0 5.92957 0.053788 5.74771 0.156174C5.56586 0.25856 5.41346 0.406088 5.30523 0.584523Z"/>
                        <path d="M6.95057 8.5624C6.95057 8.89772 6.67874 9.16955 6.34343 9.16955C6.00811 9.16955 5.73628 8.89772 5.73628 8.5624C5.73628 8.22709 6.00811 7.95526 6.34343 7.95526C6.67874 7.95526 6.95057 8.22709 6.95057 8.5624Z"/>
                        </mask>
                        <path d="M6.69344 3.70524C6.69344 3.51194 6.53674 3.35524 6.34344 3.35524C6.15014 3.35524 5.99344 3.51194 5.99344 3.70524H6.69344ZM5.99344 6.13381C5.99344 6.32711 6.15014 6.48381 6.34344 6.48381C6.53674 6.48381 6.69344 6.32711 6.69344 6.13381H5.99344ZM5.99344 3.70524V6.13381H6.69344V3.70524H5.99344ZM5.30523 0.584523L4.70672 0.221478L4.70472 0.224813L5.30523 0.584523ZM0.162726 9.16952L-0.437858 8.80977L-0.443468 8.81948L0.162726 9.16952ZM1.20094 10.991L1.19325 11.691H1.20094V10.991ZM11.4859 10.991V11.691L11.4936 11.6909L11.4859 10.991ZM12.5242 9.16952L13.1304 8.81944L13.1247 8.80981L12.5242 9.16952ZM7.38165 0.584523L7.98217 0.224808L7.98015 0.221484L7.38165 0.584523ZM6.34344 0V-0.7V0ZM4.70472 0.224813L-0.437781 8.80981L0.763233 9.52923L5.90573 0.944233L4.70472 0.224813ZM-0.443468 8.81948C-0.610615 9.10894 -0.699057 9.43712 -0.699992 9.77138L0.700002 9.7753C0.700253 9.6855 0.724014 9.59733 0.768919 9.51957L-0.443468 8.81948ZM-0.699992 9.77138C-0.700928 10.1056 -0.614326 10.4343 -0.448802 10.7247L0.767486 10.0314C0.723017 9.9534 0.699751 9.8651 0.700002 9.7753L-0.699992 9.77138ZM-0.448802 10.7247C-0.283278 11.0151 -0.0446023 11.2571 0.243481 11.4266L0.953473 10.22C0.876078 10.1744 0.811955 10.1094 0.767486 10.0314L-0.448802 10.7247ZM0.243481 11.4266C0.531562 11.5961 0.859009 11.6872 1.19325 11.6909L1.20863 10.291C1.11884 10.29 1.03087 10.2655 0.953473 10.22L0.243481 11.4266ZM1.20094 11.691H11.4859V10.291H1.20094V11.691ZM11.4936 11.6909C11.8279 11.6872 12.1553 11.5961 12.4434 11.4266L11.7334 10.22C11.656 10.2655 11.568 10.29 11.4782 10.291L11.4936 11.6909ZM12.4434 11.4266C12.7315 11.2571 12.9702 11.0151 13.1357 10.7247L11.9194 10.0314C11.8749 10.1094 11.8108 10.1744 11.7334 10.22L12.4434 11.4266ZM13.1357 10.7247C13.3012 10.4343 13.3878 10.1056 13.3869 9.77138L11.9869 9.7753C11.9871 9.8651 11.9639 9.9534 11.9194 10.0314L13.1357 10.7247ZM13.3869 9.77138C13.3859 9.43712 13.2975 9.10894 13.1303 8.81948L11.918 9.51957C11.9629 9.59733 11.9866 9.6855 11.9869 9.7753L13.3869 9.77138ZM13.1247 8.80981L7.98216 0.224813L6.78115 0.944233L11.9236 9.52923L13.1247 8.80981ZM7.98015 0.221484C7.80952 -0.0598146 7.56927 -0.292388 7.28258 -0.453796L6.59575 0.766144C6.67277 0.809508 6.73731 0.87199 6.78315 0.947563L7.98015 0.221484ZM7.28258 -0.453796C6.99589 -0.615205 6.67244 -0.7 6.34344 -0.7V0.7C6.43183 0.7 6.51873 0.722781 6.59575 0.766144L7.28258 -0.453796ZM6.34344 -0.7C6.01444 -0.7 5.69099 -0.615205 5.4043 -0.453796L6.09113 0.766144C6.16815 0.722781 6.25505 0.7 6.34344 0.7V-0.7ZM5.4043 -0.453796C5.11761 -0.292388 4.87736 -0.0598146 4.70673 0.221484L5.90373 0.947563C5.94957 0.87199 6.01411 0.809508 6.09113 0.766144L5.4043 -0.453796ZM6.25057 8.5624C6.25057 8.51112 6.29214 8.46955 6.34343 8.46955V9.86955C7.06534 9.86955 7.65057 9.28432 7.65057 8.5624H6.25057ZM6.34343 8.46955C6.39471 8.46955 6.43628 8.51112 6.43628 8.5624H5.03628C5.03628 9.28432 5.62151 9.86955 6.34343 9.86955V8.46955ZM6.43628 8.5624C6.43628 8.61369 6.39471 8.65526 6.34343 8.65526V7.25526C5.62151 7.25526 5.03628 7.84049 5.03628 8.5624H6.43628ZM6.34343 8.65526C6.29214 8.65526 6.25057 8.61369 6.25057 8.5624H7.65057C7.65057 7.84049 7.06534 7.25526 6.34343 7.25526V8.65526Z" fill="#D06262" mask="url(#path-1-inside-1)"/>
                    </svg>
                    <span v-if="lang === 'ru'">Это обязательное поле</span>
                    <span v-if="lang === 'kk'">Бұл жолды міндетті түрде жазу қажет</span>
                </div>
                <span v-if="lang === 'ru'" @click="sendContact" :style="{ 'color': data.impairedRegime ? '#000000' : '#ffffff', 'background' : data.impairedRegime ? '#ffffff' : '#568357' }" class="submit-question">Отправить</span>
                <span v-if="lang === 'kk'" @click="sendContact" :style="{ 'color': data.impairedRegime ? '#000000' : '#ffffff', 'background' : data.impairedRegime ? '#ffffff' : '#568357' }" class="submit-question">Жіберу</span>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    props: [ 'data' ],
    data(){
        return {
            showModal: false,
            name: '',
            email: '',
            text: '',
            lang: 'kk'
        }
    },
    created(){
        if( localStorage.getItem('xyzCustomLang') ){
            this.lang = localStorage.getItem('xyzCustomLang')
        }
    },
    methods: {
        validateForm(e){
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(e.target.name === 'name'){
                if(String(e.target.value).length === 0 ){
                    e.srcElement.classList.add('error')
                    document.getElementById('err-name').style.display = 'flex'
                } else {
                    e.srcElement.classList.remove('error')
                    document.getElementById('err-name').style.display = 'none'
                }
            }
            if(e.target.name === 'text'){
                if(String(e.target.value).length === 0 ){
                    e.srcElement.classList.add('error')
                    document.getElementById('err-text').style.display = 'flex'
                } else {
                    e.srcElement.classList.remove('error')
                    document.getElementById('err-text').style.display = 'none'
                }
            }
            if(e.target.name === 'email'){
                if (!pattern.test(String(e.target.value).toLowerCase())) {
                    e.srcElement.classList.add('error')
                    document.getElementById('err-email').style.display = 'flex'
                } else {
                    e.srcElement.classList.remove('error')
                    document.getElementById('err-email').style.display = 'none'
                }
            }
        },
        sendContact(){
            if(this.name === ''){
                document.getElementsByName('name')[0].classList.add('error')
                document.getElementById('err-name').style.display = 'flex'
            } 
            if(this.text === ''){
                document.getElementsByName('text')[0].classList.add('error')
                document.getElementById('err-text').style.display = 'flex'
            }
            if(this.email === ''){
                document.getElementsByName('email')[0].classList.add('error')
                document.getElementById('err-email').style.display = 'flex'
            }
            if(document.getElementsByClassName('error').length !== 0) return 

            const data = {
                Username: this.name,
                Email: this.email,
                Text: this.text
            }
            axios.post( 'https://shyn.kz/mail/send?type=feedback', data, {
                headers: {
                    "Access-Control-Allow-Origin": '*'
                }
             } )
            .then((res) => {
                this.showModal = true;
                console.log(res.data)
            })
            .catch((e) => {
                alert(e);
                console.log('Error in loading news\n' + e)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    *{
		transition: all 0.6s ease;
	}
    h1, h3, h5, p, span, a, label{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .modal{
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background: rgba(51, 51, 51, 0.4);  
        .modal-content {
            position: relative;
            background: #FFFFFF;
            box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
            border-radius: 10px;
            margin: 145px auto auto auto;
            padding: 60px 56px 32px 56px;
            width: 428px;
            height: 378px;
            img{
                position: absolute;
                transform: scale(0.25) translateX(-80%) translateY(-150%);
            }
            h3, p{
                text-align: center;
            }
            h3{
                margin-top: 186px;
                font-weight: 500;
                font-size: 20px;
                line-height: 30px;
                letter-spacing: 0.04em;
            }
            p{
                margin-top: 10px;
                font-weight: 300;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: 0.04em;
            }
            span{
                cursor: pointer;
                position: absolute;
                left: 56px;
                bottom: 32px;
                width: 428px;   
                padding: 23px 0;
                background: #568357;
                border-radius: 10px;
                font-weight: 500;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                letter-spacing: 0.04em;
                color: #FFFFFF;
            }
        }
    }
    .outer{
        padding: 30px 6% 87px 18%;
        h1{
            font-weight: 500;
            font-size: 34px;
            line-height: 45px;
            letter-spacing: 0.04em;
            color: #333333;
        }
        .content{
            .left{
                position: relative;
                img{
                    position: absolute;
                    transform: scale(0.25) translateX(-150%) translateY(-150%);
                    margin: 83px auto 30px 12px;
                }
                h5{
                    margin: 40px 0 24px 0;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #333333;
                }
                p{
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 26px;
                    letter-spacing: 0.04em;
                    color: #333333;
                }
                .label{
                    a{
                        cursor: pointer;
                        margin-left: 19px;
                        margin-bottom: 16px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                }
            }
            .right{
                position: relative;
                left: 16%;
                box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                border-radius: 10px;
                padding: 39px 56px 126px 56px;
                h3{
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                }
                label{
                    margin-top: 20px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    opacity: 0.8;
                }
                input[type="text"], textarea{
                    border: 1px solid #FFFFFF;
                    margin: 8px 0 12px 0;
                    padding: 21px 42px;
                    height: 30px;
                    width: 344px;
                    border: none;
                    background: #FFFFFF;
                    border-radius: 10px;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #333333;
                }
                .error{
                    border: 1px solid #E4002F !important;
                    box-shadow: 0px 0px 10px rgba(228, 0, 47, 0.2) !important;
                }
                input[type="text"]::placeholder, textarea::placeholder{
                    opacity: 0.9;
                }
                textarea{
                    height: 102px;
                    max-height: 142px;
                }
                .submit-question{
                    cursor: pointer;
                    position: absolute;
                    bottom: 44px;
                    left: 56px;
                    width: calc(100% - 112px);
                    padding: 16px 0;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                }
            }
        }
        .err{
            display: none;
            margin: 0px auto 0 10px;
            span{
                margin: -4px auto 0 4px;
                font-weight: 300;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0.04em;
                color: #D06262;
            }
        }
    }
    @media only screen and (max-width: 1330px){
        .outer{
            padding: 30px 6% 87px 12%;
            .content{
                .right{
                    left: 16%;
                    padding: 39px 32px 126px 32px;
                    input[type="text"], textarea{
                        width: 280px;
                    }
                    .submit-question{
                        left: 32px;
                        width: calc(100% - 64px);
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 30px 12% 87px 12%;
            h1{
                font-size: 28px;
                line-height: 38px;
            }
            .content{
                flex-direction: column;
                .left{
                    width: 100%;
                    position: relative;
                    img{
                        position: absolute;
                        right: 0%;
                        transform: scale(0.22) translateX(180%) translateY(-200%);
                        margin: 83px auto 30px 12px;
                    }
                    h5{
                        margin: 20px 0 12px 0 !important;
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    p{
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    .label{
                        a{
                            cursor: pointer;
                            margin-left: 19px;
                            margin-bottom: 12px;
                            font-weight: 300;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            color: #333333;
                        }
                    }
                }
                .right{
                    margin-top: 20px;
                    width: calc(100% - 140px);
                    position: relative;
                    left: 0%;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    padding: 24px 70px 120px 70px;
                    h3{
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                    }
                    label{
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                    input[type="text"], textarea{
                        margin: 8px 0 8px 0;
                        padding: 21px 42px;
                        height: 30px;
                        width: calc(100% - 84px);
                        border: none;
                        background: #FFFFFF;
                        border-radius: 10px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    input[type="text"]::placeholder, textarea::placeholder{
                        opacity: 0.9;
                    }
                    textarea{
                        height: 102px;
                        max-height: 142px;
                    }
                    .submit-question{
                        cursor: pointer;
                        position: absolute;
                        bottom: 32px;
                        left: 70px;
                        width: calc(100% - 140px);
                        padding: 16px 0;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 30px 6% 87px 6%;
            h1{
                font-size: 26px;
                line-height: 38px;
            }
            .content{
                flex-direction: column;
                .left{
                    width: 100%;
                    position: relative;
                    img{
                        position: absolute;
                        right: 0%;
                        transform: scale(0.18) translateX(230%) translateY(-240%);
                        margin: 83px auto 30px 12px;
                    }
                    h5{
                        font-weight: 800;
                        margin: 20px 0 12px 0 !important;
                        font-size: 18px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    p{
                        width: 220px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 22px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    .label{
                        a{
                            cursor: pointer;
                            margin-left: 19px;
                            margin-bottom: 12px;
                            font-weight: 300;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            color: #333333;
                        }
                    }
                }
                .right{
                    margin-top: 20px;
                    width: calc(100% - 60px);
                    position: relative;
                    left: 0%;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    padding: 24px 30px 120px 30px;
                    h3{
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                    }
                    label{
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                    input[type="text"], textarea{
                        margin: 8px 0 8px 0;
                        padding: 12px 42px;
                        height: 30px;
                        width: calc(100% - 84px);
                        border: none;
                        background: #FFFFFF;
                        border-radius: 10px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    input[type="text"]::placeholder, textarea::placeholder{
                        opacity: 0.9;
                    }
                    textarea{
                        height: 102px;
                        max-height: 142px;
                    }
                    .submit-question{
                        cursor: pointer;
                        position: absolute;
                        bottom: 32px;
                        left: 30px;
                        width: calc(100% - 60px);
                        padding: 16px 0;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
        }
        .modal{
            .modal-content {
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 30px 16px;
                width: 80%;
                height: 290px;
                img{
                    width: 30%;
                    margin: 0 auto;
                }
                h3, p{
                    text-align: center;
                }
                h3{
                    margin-top: 12px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                p{
                    margin-top: 6px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: 0.04em;
                    color: #4F4F4F;
                }
                span{
                    cursor: pointer;
                    position: absolute;
                    left: 30px;
                    bottom: 20px;
                    width: calc(100% - 60px);   
                    padding: 23px 0;
                    background: #568357;
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                    color: #FFFFFF;
                }
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            padding: 30px 3% 87px 4%;
            h1{
                font-size: 26px;
                line-height: 38px;
            }
            .content{
                flex-direction: column;
                .left{
                    width: 100%;
                    position: relative;
                    img{
                        position: absolute;
                        right: 0%;
                        transform: scale(0.12) translateX(370%) translateY(-400%);
                        margin: 83px auto 30px 12px;
                    }
                    h5{
                        font-weight: 800;
                        margin: 20px 0 12px 0 !important;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    p{
                        width: 190px;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 18px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    .label{
                        a{
                            cursor: pointer;
                            margin-left: 10px;
                            margin-bottom: 8px;
                            font-weight: 300;
                            font-size: 14px;
                            line-height: 22px;
                            letter-spacing: 0.04em;
                            color: #333333;
                        }
                    }
                }
                .right{
                    margin-top: 20px;
                    width: calc(100% - 40px);
                    position: relative;
                    left: 0%;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    padding: 24px 20px 120px 20px;
                    h3{
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                    }
                    label{
                        margin-top: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        opacity: 0.8;
                    }
                    input[type="text"], textarea{
                        margin: 8px 0 8px 0;
                        padding: 12px 42px;
                        height: 30px;
                        width: calc(100% - 84px);
                        border: none;
                        background: #FFFFFF;
                        border-radius: 10px;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 30px;
                        letter-spacing: 0.04em;
                        color: #333333;
                    }
                    input[type="text"]::placeholder, textarea::placeholder{
                        opacity: 0.9;
                    }
                    textarea{
                        height: 102px;
                        max-height: 142px;
                    }
                    .submit-question{
                        cursor: pointer;
                        position: absolute;
                        bottom: 32px;
                        left: 20px;
                        width: calc(100% - 40px);
                        padding: 16px 0;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                    }
                }
            }
        }
        .modal{
            .modal-content {
                background: #FFFFFF;
                box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
                border-radius: 10px;
                margin: 145px auto auto auto;
                padding: 30px 16px;
                width: 86%;
                height: 240px;
                img{
                    width: 110px;
                    margin: 0 auto;
                }
                h3, p{
                    text-align: center;
                }
                h3{
                    margin-top: 12px;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 30px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
                p{
                    margin-top: 6px;
                    font-weight: 300;
                    font-size: 14px;
                    line-height: 14px;
                    letter-spacing: 0.04em;
                    color: #4F4F4F;
                }
                span{
                    cursor: pointer;
                    position: absolute;
                    left: 30px;
                    bottom: 20px;
                    width: calc(100% - 60px);   
                    padding: 12px 0;
                    background: #568357;
                    border-radius: 10px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    letter-spacing: 0.04em;
                    color: #FFFFFF;
                }
            }
        }
    }
</style>

